<template lang="pug">
div
    .text-center
        img(v-bind:src="logo" width="80px")

        .col-sm-12.text-center.p-t-1
            small.block(v-if="outlet.company_details") {{ outlet.company_details.name }}
            small.block {{ outlet.name }}
            small.block {{ outlet.address }}
            small.block {{ receiptDateFormatModal(pgsql_transaction.receipt_date, null) }}
            small.block(v-if="outlet.phone_no") {{ trans('receipt.phone') }} {{ outlet.phone_no }}
            small.block {{ trans('receipt.site') }} {{ outlet.code }}
            small.block(v-if="stan") {{ trans('receipt.stan') }} {{ stan }}
            small.block(v-if="approvalCode") {{ trans('receipt.approval_code') }} {{ approvalCode }}
            small.block(v-if="referenceNo") {{ trans('receipt.reference_number') }} {{ referenceNo }}
            small.block(v-if="ghlPaymentReferenceNo") {{ trans('receipt.payment_reference_number') }} {{ ghlPaymentReferenceNo }}
            small.block(v-if="ghlRefundReferenceNo") {{ trans('receipt.refund_reference_number') }} {{ ghlRefundReferenceNo }}
            small.block(v-if="ghlMerchantId") {{ trans('receipt.mid') }} {{ ghlMerchantId }}
            small.block(v-if="ghlTerminalId") {{ trans('receipt.tid') }} {{ ghlTerminalId }}

    .row(v-if="!pgsql_transaction.drawer_session && !pgsql_transaction.forecourt_attendant")
        .col-sm-12
            hr

            .row
                .col-xs-4
                    small.pull-left {{ trans('receipt.invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

            .row(v-if="shouldShowOriginalInvoice")
                .col-xs-4
                .col-xs-4
                .col-xs-4
                    small.pull-left {{ trans('receipt.original_invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt.original_receipt) }}

    .row(v-else-if="pgsql_transaction.forecourt_attendant && pgsql_transaction.forecourt_attendant.id")
        .col-sm-12
            hr

            .row
                .col-xs-4
                    small.pull-left {{ trans('receipt.invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

            .row(v-if="shouldShowOriginalInvoice")
                .col-xs-4
                .col-xs-4
                .col-xs-4
                    small.pull-left {{ trans('receipt.original_invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt.original_receipt) }}

        .col-sm-12
            hr

            .row
                .col-xs-4
                    small.pull-left {{ trans('receipt.attendant') }}
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.staff_name }}

                .col-xs-4
                    small.pull-left {{ trans('receipt.attendant_card_number') }}
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.card_pan }}

                .col-xs-4
                    small.pull-left {{ trans('receipt.attendant_till_number') }}
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.sequence_number }}

        .col-sm-12
            hr

    .row(v-else)
        .col-sm-12
            hr

        .col-sm-12
            .row
                .col-xs-4.text-break
                    small.pull-left {{ trans('receipt.pos') }}
                    br
                    h5.pull-left {{ pgsql_transaction.drawer_session.device_name }}

                .col-xs-4
                    small.pull-left {{ trans('receipt.staff') }}
                    br
                    h5.pull-left {{ pgsql_transaction.drawer_session.staff_name }}

                .col-xs-4
                    small.pull-left {{ trans('receipt.invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

            .row
                .col-xs-4
                    small.pull-left {{ trans('receipt.shift_number') }}
                    br
                    h5.pull-left {{ pgsql_transaction.drawer_session.sequence_number }}
                .col-xs-4(v-if="shouldShowOriginalInvoice")
                .col-xs-4(v-if="shouldShowOriginalInvoice")
                    small.pull-left {{ trans('receipt.original_invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt.original_receipt) }}
        .col-sm-12
            hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transactionPostgres', [
            'pgsql_transaction',
            'outlet',
            'receipt',
            'receiptType',
            'approvalCode',
            'referenceNo',
            'stan',
            'ghlPaymentReferenceNo',
            'ghlRefundReferenceNo',
            'ghlMerchantId',
            'ghlTerminalId',
        ]),

        logo() {
            return Auth.franchise().logo;
        },
    },
};
</script>
